import { useState, useContext, useEffect } from "react";
import * as React from "react";

import { Link, NavLink, withRouter } from "react-router-dom";
import NavAntDropdown from "./NavAntDropdown";
import classNames from "classnames";
import AuthContext from "src/context/AuthContext";
import Button from "src/components/buttons/Button";
import ClientsiteNavBar from "./ClientsiteNavBar";
import { AdminPermissions } from "src/common/Permissions";
import logo from "src/assets/icons/Impirica_logo_large_white.png";

interface IProps {
	className?: string;
	location?: any;
	history?: any;
	match?: any;
}

const NavBar = (props: IProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const { currentUser } = useContext(AuthContext);
	const isGlobalAdmin =
		currentUser &&
		currentUser.permissions &&
		currentUser.permissions.includes(AdminPermissions.GlobalAdmin);
	const isGlobalAdminAndIsInAdminSite =
		isGlobalAdmin && props.location.pathname.split("/").includes("admin");

	useEffect(() => {
		if (isOpen) {
			document.body.classList.add("nav-open");
		} else {
			// TODO: Better way to show scrollbar
			setTimeout(() => document.body.classList.remove("nav-open"), 200);
		}
	}, [isOpen]);

	const onToggleNav = () => {
		setIsOpen(!isOpen);
	};

	const onCloseNav = () => {
		setIsOpen(false);
	};

	if (!currentUser) {
		console.error("User is not logged in");
		return null;
	}

	const renderOrgAdminNavItems = () => {
		if (
			currentUser !== undefined &&
			currentUser.roles !== undefined &&
			currentUser.permissions &&
			currentUser.permissions.length > 0
		) {
			return (
				<li className="nav-item">
					<NavLink
						className="nav-link"
						to="/admin/organizations"
						onClick={onCloseNav}
					>
						<span>Organizations</span>
					</NavLink>
				</li>
			);
		} else {
			return null;
		}
	};

	const extractParamsFromUrl = (pathName: string) => {
		const splitUrl = pathName.split("/").slice(1);

		const params = {
			organizationId: splitUrl[1],
			datasetId: splitUrl[3],
			clientId: "",
			resultId: "",
		};

		if (splitUrl.includes("details") || splitUrl.includes("results")) {
			params.clientId = splitUrl[5];
		}

		if (splitUrl.includes("Core")) {
			params.resultId = splitUrl[5];
		}

		return params;
	};

	const getparamIds = (pathname: string) => {
		const splitUrl = pathname.split("/").slice(1);
		if (splitUrl.includes("datasets") && splitUrl.includes("organizations")) {
			return {
				organizationId: splitUrl[1],
				datasetId: splitUrl[3],
			};
		}
		return null;
	};

	const renderCoreTesterNavItems = () => {
		const showCoreTesterNav = checkWindowHrefToDisplayNavItems();
		const params = getparamIds(props.location.pathname);
		const currentUserDatasets = checkCurrentUserDatasets();
		const currentUserIsPartOfDataset = isCurrentUserPartOfDataset(
			props.location.pathname,
			currentUserDatasets
		);
		if (
			(showCoreTesterNav && currentUserIsPartOfDataset) ||
			(showCoreTesterNav &&
				currentUser.permissions!.includes(AdminPermissions.GlobalAdmin))
		) {
			return (
				<React.Fragment>
					<li className="nav-item">
						<NavLink
							to={`/organizations/${params!.organizationId}/datasets/${
								params!.datasetId
							}/clients`}
							className="nav-link"
						>
							<span>Participants</span>
						</NavLink>
					</li>
					<li className="nav-item">
						<NavLink
							to={`/organizations/${params!.organizationId}/datasets/${
								params!.datasetId
							}/results`}
							className="nav-link"
						>
							<span>Results</span>
						</NavLink>
					</li>
				</React.Fragment>
			);
		} else {
			return null;
		}
	};

	const checkCurrentUserDatasets = () => {
		return currentUser.datasetPermissions!.map(
			(perm: DatasetPermissionDTO) => perm.datasetId
		);
	};

	const isCurrentUserPartOfDataset = (pathName: string, datasets: any[]) => {
		const splitUrl = pathName.split("/").slice(1);
		let datasetId = 0;
		if (splitUrl.includes("datasets")) {
			datasetId = +splitUrl[3];
			return datasets.includes(datasetId);
		}
		return false;
	};

	const checkWindowHrefToDisplayNavItems = () => {
		// this is gross but its a quick fix
		const href = props.location.pathname;
		const params = extractParamsFromUrl(props.location.pathname);
		const matchingHref = [
			`/organizations/${params.organizationId}/datasets/${params.datasetId}/clients`,
			`/organizations/${params.organizationId}/datasets/${params.datasetId}/results`,
			`/organizations/${params.organizationId}/datasets/${params.datasetId}/clients/${params.clientId}/results`,
			`/organizations/${params.organizationId}/datasets/${params.datasetId}/clients/${params.clientId}/details`,
			`/organizations/${params.organizationId}/datasets/${params.datasetId}/results/${params.resultId}/Core`,
		];
		return matchingHref.includes(href);
	};

	// still prefer a solution that listens to route changing, but cannot really setState during unmount
	const shouldDisplayDatasetName = () => {
		const params = extractParamsFromUrl(props.location.pathname);
		return params.datasetId && !props.location.pathname.includes("/admin");
	};

	const shouldDisplayClientsiteNavbar: boolean =
		!props.location.pathname.includes("client-training") &&
		Boolean(extractParamsFromUrl(props.location.pathname).organizationId) &&
		!props.location.pathname.includes("/admin");

	const renderGlobalAdminNavItems = () => {
		if (isGlobalAdmin) {
			return (
				<>
					<li className="nav-item">
						<NavLink
							className="nav-link"
							to="/admin/reports"
							onClick={onCloseNav}
						>
							<span>Reports</span>
						</NavLink>
					</li>
					{/* <li className="nav-item">
						<NavLink className="nav-link" to="/admin/fleet-errors" onClick={onCloseNav}>
							<span>Fleet-Errors</span>
						</NavLink>
					</li> */}
					<li className="nav-item">
						{/* Note: this component is not generic, if you want to use it somewhere else try refactor the component first */}
						<NavAntDropdown title="Admin Tools" />
					</li>
				</>
			);
		} else {
			return null;
		}
	};

	const renderTrainingCourseNavItem = () => {
		return (
			<li className="nav-item">
				<NavLink
					className="nav-link"
					to="/client-training"
					onClick={onCloseNav}
				>
					<span>Training</span>
				</NavLink>
			</li>
		);
	};

	const renderSupportNavItem = () => {
		return (
			<li className="nav-item">
				<a
					className="nav-link"
					href="https://support.impirica.tech"
					target="_blank"
					rel="noopener noreferrer"
				>
					<span>Support</span>
				</a>
			</li>
		);
	};

	return (
		<React.Fragment>
			<nav
				className={classNames(
					"bg-dark",
					"navbar navbar-expand-lg navbar-dark",
					props.className
				)}
			>
				<Link to="/" className="navbar-brand">
					<img src={logo} alt="Impirica" className="brand-logo" />
				</Link>
				<Button
					className="d-lg-none ml-auto navbar-toggler"
					onClick={onToggleNav}
				>
					Menu
				</Button>
				<div
					className={classNames("navbar-collapse bg-dark", {
						collapse: !isOpen,
					})}
				>
					<div className={classNames("navbar-nav d-lg-none bg-dark")}>
						<Button
							className="d-block ml-auto mr-3 navbar-toggler nav-link"
							onClick={onCloseNav}
						>
							Close
						</Button>
						<Link
							to="/"
							className="mt-4 navbar-brand brand-logo nav-link"
							onClick={onCloseNav}
						>
							<img src={logo} alt="ExceleRATE" className="brand-logo" />
						</Link>
					</div>
					<ul className={classNames("navbar-nav")}>
						{renderOrgAdminNavItems()}
						{renderGlobalAdminNavItems()}
					</ul>
					<ul className={classNames("navbar-nav ml-lg-auto")}>
						<li className="nav-item-heading d-lg-none">
							<hr className="border-light disabled" />
						</li>
						<li className="nav-item">
							<strong className="nav-link disable-pointer-events">
								{isGlobalAdminAndIsInAdminSite && (
									<span> Global Admin User:</span>
								)}
								{(currentUser &&
									currentUser.firstName &&
									currentUser.lastName &&
									currentUser.firstName.concat(" ", currentUser.lastName)) ||
									"Username"}
							</strong>
						</li>
						{renderSupportNavItem()}
						{renderTrainingCourseNavItem()}
						<li className="nav-item">
							<span
								className="nav-link"
								onClick={() => (window.location.href = "/bff/logout")}
							>
								Log out
							</span>
						</li>
					</ul>
				</div>
			</nav>
			{shouldDisplayClientsiteNavbar && (
				<ClientsiteNavBar
					extractParamsFromUrl={extractParamsFromUrl}
					location={location}
					renderCoreTesterNavItems={renderCoreTesterNavItems}
					shouldDisplayDatasetName={shouldDisplayDatasetName}
				/>
			)}
		</React.Fragment>
	);
};

export default withRouter(NavBar);
